// AccountSettingsForm.js
import React, { useEffect, useRef, useState} from 'react';
import './Form.css'
import { interpolateRgbBasisClosed } from 'd3';

const AccountSettingsForm = ({uid, pseudo, description, channel, setUserpseudo, logout}) => {
  const [nickname, setNickname] = useState(pseudo);
  const [role, setRole] = useState('');
  const [userDescription, setUserDescription] = useState(description)
  const [currentPassword, setCurrentPassword] = useState('');
  const [maskedCurrentPassword, setMaskedCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [maskedNewPassword, setMaskedNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [maskedConfirmNewPassword, setMaskedConfirmNewPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const passwordRef = useRef(null);

  useEffect(() => {
    channel.on('update done', (data) => {
      setUserpseudo('')
    });
    channel.on('update not allowed', (data) => {
      setPasswordError('mise à jour impossible: ' + data['message'])
    });

  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérifier que les nouveaux mots de passe sont identiques
    if (newPassword !== confirmNewPassword) {
      setPasswordError('Les nouveaux mots de passe ne correspondent pas.');
      return;
    }

    const parameters = {
      'uid' : uid,
      'pseudo' : nickname,
      'desc' : userDescription,
      'cpwd' : currentPassword,
      'npwd': newPassword
    }

    channel.emit('update user', parameters);
  };


  const handleCancel = async (e) => {
    setUserpseudo('')
  };

function mergePwdValues(masked, clear) {
  let res = ''
  let idx = 0
  for (let i = 0; i < masked.length; i++) {
    const c = masked.charAt(i);
    if (c === '*'){
      res += clear.charAt(idx)
      idx += 1
    } else {
      res += c
    }
  }  return res
}

  const handleConfirmedInput = async (e) => {
    const value = mergePwdValues(e.target.value, confirmNewPassword);
    setConfirmNewPassword(value);
    setMaskedConfirmNewPassword('*'.repeat(value.length));
  }

  const handleCurrentInput = async (e) => {
    const value = mergePwdValues(e.target.value, currentPassword);
    setCurrentPassword(value);
    setMaskedCurrentPassword('*'.repeat(value.length));
  }

  const handleNewInput = async (e) => {
    const value = mergePwdValues(e.target.value, newPassword);
    setNewPassword(value);
    setMaskedNewPassword('*'.repeat(value.length));
  }


  return (
    <form onSubmit={handleSubmit} className='altai-ego-form my-5'>
      {/* ... autres champs du formulaire */}
      <div className="row mb-3">
      <div>
      <label htmlFor="current-password" className='form-label'>mot de passe actuel</label>
        <input
          className ="form-control"
          type="text"
          id="cpassword"
          value={maskedCurrentPassword}
          onChange={handleCurrentInput}
          autoComplete='off'
          required
        />
      </div>
      <div>
      <label htmlFor="pseudo" className='form-label'>pseudo visible</label>
        <input
          type="text"
          id="pseudo"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          required
        />
      </div>
      <div>
      <label htmlFor="user-description" className='form-label'>Décrivez vous</label>
      <textarea
          id="description"
          name="description"
          value={userDescription}
          onChange={(e) => setUserDescription(e.target.value)}
          rows={2}
        ></textarea>

      </div>
      <div>
        <label htmlFor="new-password" className='form-label'>nouveau mot de passe</label>
        <input
          type="text"
          id="npassword"
          onChange={handleNewInput}
          value={maskedNewPassword}
          autoComplete='off'
          required
        />
      </div>
      <div>
        <label htmlFor="confirm-new-password" className='form-label'>Confirmer le nouveau mot de passe</label>
        <input
          type="text"
          id="cnpassword"
          onChange={handleConfirmedInput}
          value={maskedConfirmNewPassword}
          autoComplete='off'
          required
        />
      </div>
      {passwordError && <div className="error">{passwordError}</div>}
      <button type="submit">Mettre à jour le compte</button>
      <button type="cancel" onClick={handleCancel}>Annuler</button>
      </div>
    </form>
  );
};

export default AccountSettingsForm;